import styled from "styled-components";

export const SeccondModalButtons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
`;

export const CloseIconContainer = styled.div`
  display: flex;
  position:absolute;
  top:-42px;
  left:auto;
  right:-10px;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  color:#ffffff;
  cursor:pointer;
`;

export const ModalContent = styled.div`
  background-color: #00ffff;

  @media (max-width: 769px) {
    text-align- center
  }
`;

export const ImagePush = styled.h1`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 130px;
  max-height: 130px;
`;

export const Title = styled.h1`
  padding: 15px;
  text-align: center;
  font: normal normal 900 15px/26px Roboto;
  letter-spacing: 0.48px;
  color: #000FFF;
`;

export const Caption = styled.h1`
  text-align: center;
  font: normal normal normal 11px/24px Roboto;
  letter-spacing: 0.38px;
  color: #000FFF;
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: right;
  align-items: right;
  flex-direction: row;

  @media (max-width: 769px) {
    justify-content: center;
    align-items: center;
  }
`;

export const Button = styled.div`
  width: 33%;
  height: 40px;
  margin-top: 15px;
  margin-left: 1px;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000004d;
  outline: none !important;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none !important;
  padding: 1px;
  color: #ffffff;
  &:hover {
    filter: brightness(90%);
  }
  span {
    color: #ffffff;
  }
  @media (max-width: 769px) {
    width: 100%;
  }
  @media (min-width: 855px) and (max-width: 975px) {
    font-size: 0.9rem;
  }
`;

export const BodyContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 20px;
`;


export const ButtonLink = styled.div`
  font: normal normal 900 10px/19px Roboto;
  letter-spacing: 0.34px;
  color: #000FFF;
`;
